module.exports = __webpack_public_path__ + "img/fasong.5abb0575.png";